module.exports = __webpack_public_path__ + "src/img/zalando/img-iphones-pdp.fe6b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-iphones-pdp.jpg
// module id = 124
// module chunks = 0